export const uniNewcomerHtml = `  
<table
    style="
        width: {{ 1110 * scale }}px;
        border-collapse: collapse;
        font-size: 14px;
        border: 1px solid #D2D2D5;
        background-color: #EBEBED;
        font-family: Arial, Helvetica, sans-serif;
        color: #000000;
        padding: 0px;
        margin: 0px;
    "
>
<tbody>
       <!-- ROW header start -->
        <tr>
            <td colspan="2" style="border: 1px solid #D2D2D5; box-sizing: border-box; padding: 0px;">
                <table style="width: 100%; border-collapse: collapse; border: none; padding: 0px; margin: 0px;">
                    <tr>
                        <td colspan="4" style="height: 20px; padding: 0px;"></td>
                    </tr>
                    <tr>
                        <td style="width: {{ 20 * scale }}px; padding: 0px;"></td>
                        <td style="width: {{ 100 * scale }}px; padding: 0px;">
                            <img style="width: 100%; height: auto; object-fit: contain;" alt="logo"
                                src="{{ executeImage('logoVention-black.png', isDownload) }}"
                            />
                        </td>
                        <td style="width: {{ 820 * scale }}px; padding: 0px;"></td>
                        <td style="width: {{ 20 * scale }}px; padding: 0px;"></td>
                    </tr>
                    <tr>
                        <td colspan="4" style="height: 120px; padding: 0px;"></td>
                    </tr>
                </table>
            </td>
        </tr>
        <!-- ROW header end -->
        {% originSections?.forEach(section => { %}
            <tr>
            <td  style="width: {{ 300 * scale }}px; border: 1px solid #D2D2D5; box-sizing: border-box; vertical-align:top; padding: 0px;">
                <table style="width: 100%; border-collapse: collapse; border: none; padding: 0px; margin: 0px;">
                    <tr>
                        <td colspan="3" style="height: 24px; padding: 0px;"></td>
                    </tr>
                    <tr>
                        <td style="width: {{ 20 * scale }}px; padding: 0px;"></td>
                        <td style="width: {{ 280 * scale }}px; padding: 0px; font-size: 14px; font-family: Arial, Helvetica, sans-serif;" class="section-name">
                        {% if((section.originSection?.name === 'Greeting1' || section.originSection?.name === 'Greeting2')  && lang === 'eng') { %}
                            Hi, {{ _.get(context, "newcomer.firstName") }}!
                        {% } else if(section.originSection?.name === 'Greeting1' && lang === 'ru'){ %}  
                            Привет, {{ _.get(context, "newcomer.firstRussianName") }}!  
                        {% } else { %}
                            {{section.originSection?.name}}
                        {% } %}    
                        </td>
                        <td style="width: {{ 20 * scale }}px; padding: 0px;"></td>
                    </tr>
                    <tr>
                        <td colspan="3" style="height: 24px; padding: 0px;"></td>
                    </tr>
                </table>
            </td>
            <td  style="width: {{ 660 * scale }}px; border: 1px solid #D2D2D5; box-sizing: border-box; padding: 0px;">
                <table style="width: 100%; border: none; border-collapse: collapse; padding: 0px; margin: 0px;">        
                {% section.originSection.originBlocks.forEach((block, idx) => { %}
                    <!-- ROW Block start -->
                    <tr>
                        <td colspan="3" style="height: 24px; padding: 0px;"></td>
                    </tr>
            
                    <!-- ROW Title start -->   
                    {% if(block.originBlock.title) { %}
                    <tr>
                        <td style="width: {{ 20 * scale }}px; padding: 0px;"></td>
                        <td style="width: {{ 600 * scale }}px; padding: 0px;">
                            <table style="width: 100%; border-collapse: collapse; border: none; padding: 0px; margin: 0px;">
                                <tr>
                                    <td style="width: {{ 520 * scale }}px;
                                        padding: 0px; color: #FF6A47;
                                        font-size: 16px;
                                        font-weight: bold; vertical-align:top;
                                        font-family: Arial, Helvetica, sans-serif;
                                        height: 32px;"
                                        class="title"
                                    >
                                        {{block.originBlock.title}}
                                    </td>
                                    <td style="width: {{ 48 * scale }}px; padding: 0px;"></td>
                                    <td style="width: {{ 30 * scale }}px; padding: 0px; vertical-align: top;  height: 32px;">
                                    {% if(block.originBlock.link) { %}
                                        <a style="text-decoration: none;"
                                            href="{{block.originBlock.link}}"
                                            target="_blank"
                                        >
                                            <img alt="arrow-link" src="{{ executeImage('arrowRoundLink.png', isDownload) }}" style="width: 100%; vertical-align: middle;"/>
                                        </a>
                                    {% } %}
                                    </td>
                                </tr>
                            </table>
                        </td>
                        <td style="width: {{ 20 * scale }}px; padding: 0px;"></td>
                    </tr>
                    {% } %}
                    <!-- ROW Title end --> 
                    <!-- ROW Description start --> 
                    <tr>
                        <td style="width: {{ 20 * scale }}px; padding: 0px;"></td>
                        <td style="width: {{ 600 * scale }}px; padding: 0px;">
                            <table style="width: 100%; border-collapse: collapse; border: none; padding: 0px; margin: 0px;">
                                <tr>
                                    <td style=" width: {{ 520 * scale }}px; font-size: 14px; padding: 0px; vertical-align:middle; font-family: Arial, Helvetica, sans-serif;"
                                        class="description">
                                    {% if(section.originSection?.name === 'Greeting1' && lang === 'eng') { %}
                                       {{ moment(new Date()).format("D MMMM") }} {{block.originBlock.description.split("\\n").join("<br>")}}
                                    {% } else if(section.originSection?.name === 'Greeting2' && lang === 'eng')  { %}
                                       {{block.originBlock.description.split("\\n").join("<br>")}}
                                    {% } else if(section.originSection?.name === 'Greeting1' && lang === 'ru')  { %}
                                        Мы обведем {{ moment(new Date()).format("D MMMM") }} {{block.originBlock.description.split("\\n").join("<br>")}}   
                                    {% } else { %}
                                       {{block.originBlock.description.split("\\n").join("<br>")}}
                                    {% } %}
                                    </td>
                                    <td style="width: {{ 48 * scale }}px; padding: 0px;  height: 32px;"></td>
                                    <td style="width: {{ 30 * scale }}px; padding: 0px; vertical-align: top;  height: 32px;">
                                    {% if(!block.originBlock.title && block.originBlock.link) { %}
                                        <a style="text-decoration: none;"
                                            href="{{block.originBlock.link}}"
                                            target="_blank"
                                        >
                                            <img alt="arrow-link" src="{{ executeImage('arrowRoundLink.png', isDownload) }}" style="width: 100%; vertical-align: middle;"/>
                                        </a>
                                    {% } %}
                                    </td>
                                </tr>
                            </table>
                        </td>
                        <td style="width: {{ 20 * scale }}px; padding: 0px;"></td>
                    </tr>
                    <!-- ROW Description end --> 
                    <!-- ROW Employee info start --> 
                    {% if(block.originBlock.contactsType) { %}
                    <tr>
                        <td style="width: {{ 20 * scale }}px; padding: 0px;"></td>
                        <td style="width: {{ 600 * scale }}px; padding: 0px;">
                            <table style="width: 100%; border-collapse: collapse; border: none; padding: 0px; margin: 0px;">
                            <!-- available contactsName: personnelDepartment || curatorAndManagers || hrManagers -->
                            
                                <tbody>
                                    {% _.get(context, block.originBlock.contactsName, []).forEach(item => { %}
                                    <tr>
                                        <td colspan="3" style="height: 20px; padding: 0px;"></td>
                                    </tr>
                                    <tr>
                                        <td align="left" style="width: 100px; padding: 0px;">
                                            <div align="left" style="width: 100px; height: 100px;">
                                                <img
                                                        alt="person"
                                                        src="{{ executeImage(_.get(item, 'employee.id'), isDownload, true, _.get(item, 'employee'), ImageShape.SQUARE) }}"
                                                        data-shape="SQUARE"
                                                >
                                            </div>
                                        </td>
                                        <td style="width: {{ 10 * scale }}px; padding: 0px;"></td>
                                        <td style="width: {{ 520 * scale }}px; text-align: left; padding: 0px; vertical-align: middle;">
                                            <p style="font-size: 0px; margin-bottom: 10px;">
                                                <span style="font-size: 14px;
                                                        font-weight: bold;
                                                        color: #000000;
                                                        font-family: Arial, Helvetica, sans-serif;">{{_.get(item, "employee.fullNameEng")}}</span>
                                                {% if(_.get(item, 'position', '')) { %}
                                                <span style="font-size: 14px; font-weight: bold; color: #000000; font-family: Arial, Helvetica, sans-serif;">, {{ _.get(item, 'position', '') }}</span>
                                                {% } %}
                                                {% if(_.get(item, "employee.workplace.fullName")) { %}
                                                <span style="font-size: 14px; font-weight: bold; color: #000000; font-family: Arial, Helvetica, sans-serif;">, {{ _.get(item, "employee.workplace.fullName") }}</span>
                                                {% } %}
                                            </p>
                                            <p style="
                                                font-size: 14px;
                                                color: #000000;
                                                font-family: Arial, Helvetica, sans-serif;
                                                margin: 0px;
                                                
                                            "
                                            >
                                            {% if(block.originBlock.contactsType === 'skype') { %}
                                              {% if(_.get(item, 'employee.skype')) { %}
                                                  <span style="font-family: Arial, Helvetica, sans-serif;">Skype: </span>
                                                  <a style="
                                                      color: #000000;
                                                      text-decoration: none;
                                                      font-size: 14px;
                                                      font-family: Arial, Helvetica, sans-serif;"
                                                      href="skype:{{ _.get(item, 'employee.skype') }}?chat"
                                                      target="_blank"
                                                  >
                                                      {{ _.get(item, 'employee.skype') }}
                                                  </a>
                                              {% } %}
                                            {% } else if(block.originBlock.contactsType === 'telegram') { %}
                                              {% if(_.get(item, 'employee.telegram')) { %}
                                                  <span style="font-family: Arial, Helvetica, sans-serif;">Telegram: </span>
                                                  <a style="
                                                      color: #000000;
                                                      text-decoration: none;
                                                      font-size: 14px;
                                                      font-family: Arial, Helvetica, sans-serif;"
                                                      href="https://t.me/{{ _.get(item, 'employee.telegram', '') }}"
                                                      target="_blank"
                                                  >
                                                      {{ _.get(item, 'employee.telegram') }}
                                                  </a>
                                              {% } %}
                                            {% } else if(block.originBlock.contactsType === 'email') { %}
                                                {% if(_.get(item, 'employee.email')) { %}
                                                  <span style="font-family: Arial, Helvetica, sans-serif;">Email: </span>
                                                  <a style="
                                                      color: #000000;
                                                      text-decoration: none;
                                                      font-size: 14px;
                                                      font-family: Arial, Helvetica, sans-serif;"
                                                      href="mailto:{{ _.get(item, 'employee.email') }}"
                                                      target="_blank"
                                                  >
                                                      {{ _.get(item, 'employee.email') }}
                                                  </a>
                                               {% } %}
                                            {% } %}
                                            </p>
                                        </td>
                                    </tr>
                                    {% }) %}
                                </tbody>
                            </table>
                        </td>
                        <td style="width: {{ 20 * scale }}px; padding: 0px;"></td>
                    </tr>
                    {% } %}
                    <!-- ROW Employee info end --> 
                    {% if((section.originSection.originBlocks.length > idx && section.originSection.originBlocks[idx].originBlock.hasBottomBorder) || section.originSection.originBlocks.length === idx+1 ) { %}
                    <tr>
                        <td colspan="3" style="height: 24px; padding: 0px;"></td>
                    </tr>
                    {% } %}
                    {% if(block.originBlock.hasBottomBorder && section.originSection.originBlocks.length !== idx+1) { %}
                    <tr>
                        <td colspan="3" style="height: 1px; padding: 0px; background-color: #D2D2D5;"></td>
                    </tr>
                     {% } %}
                    <!-- ROW Block end -->
                    {% }) %}
                
                </table>
            </td>
        </tr>
        {% }) %}
        <!-- ROW footer start -->
        <tr>
            <td  style="width: {{ 300 * scale }}px; box-sizing: border-box; vertical-align: top; padding: 0px;">
                <table style="width: 100%; border-collapse: collapse; border: none; padding: 0px; margin: 0px;">
                    <tr>
                        <td colspan="3" style="height: 24px; padding: 0px;"></td>
                    </tr>
                    <tr>
                        <td style="width: {{ 20 * scale }}px; padding: 0px;"></td>
                        <td style="width: {{ 280 * scale }}px; padding: 0px; font-family: Arial, Helvetica, sans-serif;">
                            <a style="
                                color: #000000;
                                text-decoration: none;
                                font-size: 14px;
                                font-family: Arial, Helvetica, sans-serif;"
                                href="{{ executeLink(ConfigKeys.VENTION_MAIN_RESOURCE_LINK) }}"
                                target="_blank"
                            >
                                <span style="color: #000000; font-size: 14px;">join.ventionteams.com</span>              
                            </a>
                        </td>
                        <td style="width: {{ 20 * scale }}px; padding: 0px;"></td>
                    </tr>
                    <tr>
                        <td colspan="3" style="height: 24px; padding: 0px;"></td>
                    </tr>
                </table>
            </td>
            <td  style="width: {{ 660 * scale }}px; box-sizing: border-box; padding: 0px;">
                <table style="width: 100%; border-collapse: collapse; border: none; padding: 0px; margin: 0px;">
                    <tr>
                        <td style="width: {{ 20 * scale }}px; height: 20px; padding: 0px;"></td>
                        <td style="width: {{ 600 * scale }}px; height: 20px; padding: 0px;"></td>
                        <td style="width: {{ 20 * scale }}px; height: 20px; padding: 0px;"></td>
                    </tr>
                    <tr>
                        <td style="width: {{ 20 * scale }}px; padding: 0px;"></td>
                        <td style="width: {{ 600 * scale }}px; padding: 0px; font-family: Arial, Helvetica, sans-serif;">
                            <span style="font-family: Arial, Helvetica, sans-serif; font-size: 14px;">
                            {% if(lang === 'eng') { %}
                                If you have any questions — feel free to contact your HR manager.
                            {% } else if(lang === 'ru') { %}
                                Если есть вопросы — смело пиши HR-менеджеру.
                            {% } %}    
                            </span>
                        </td>
                        <td style="width: {{ 20 * scale }}px; padding: 0px;"></td>
                    </tr>
                    <tr>
                        <td style="width: {{ 20 * scale }}px; height: 20px; padding: 0px;"></td>
                        <td style="width: {{ 620 * scale }}px; height: 20px; padding: 0px;"></td>
                        <td style="width: {{ 20 * scale }}px; height: 20px; padding: 0px;"></td>
                    </tr>
                </table>
            </td>
        </tr>
        <!-- ROW footer end -->
    </tbody>
</table>
`;
